module.exports = __webpack_public_path__ + "static/media/olake-nav-active.f2820efa.svg";